import { http } from '../request'
import { normalizeListResponse } from './shared'

export interface PositionDto {
  id: number
  name: string
  category?: string
  sort: number
  remark?: string
  /** 系统类型编码（内置岗位非空；自建岗位为空）。HEAD_TEACHER/GRADE_LEADER/MORAL_DIRECTOR */
  systemType?: string
  /** 管理范围类型：AUTO_CLASS/GRADE/SCHOOL/CLASS/NONE */
  scopeType?: string
}

export interface PositionAssignmentDto {
  id: number
  staffId: number
  staffName: string | null
  positionId: number
  positionName: string
  scopeType: string
  gradeId: number | null
  gradeName: string | null
  classIds: number[]
  classNames: string[]
}

export interface AssignPositionPayload {
  staffId: number
  gradeId?: number | null
  classIds?: number[]
}

export interface AutoIdentityDto {
  staffId: number
  staffName: string | null
  identity: string
  scopeText: string
}

/** 班主任配置明细（按班级） */
export interface HeadTeacherClassDto {
  classId: number
  className: string
  gradeName: string | null
  staffId: number | null
  staffName: string | null
}

export const positionApi = {
  async list(): Promise<PositionDto[]> {
    const response = await http.get<PositionDto[]>('/settings/positions')
    return normalizeListResponse<PositionDto>(response.data)
  },
  async create(payload: Partial<PositionDto>): Promise<PositionDto> {
    const response = await http.post<PositionDto>('/settings/positions', payload)
    return response.data
  },
  async update(id: number, payload: Partial<PositionDto>): Promise<PositionDto> {
    const response = await http.put<PositionDto>(`/settings/positions/${id}`, payload)
    return response.data
  },
  async remove(id: number): Promise<void> {
    await http.delete<void>(`/settings/positions/${id}`)
  },
  async batchRemove(ids: number[]): Promise<void> {
    await http.post<void>('/settings/positions/batch-delete', { ids })
  },
  async assignments(positionId: number): Promise<PositionAssignmentDto[]> {
    const response = await http.get<PositionAssignmentDto[]>(
      `/settings/positions/${positionId}/assignments`
    )
    return normalizeListResponse<PositionAssignmentDto>(response.data)
  },
  async assign(positionId: number, payload: AssignPositionPayload): Promise<PositionAssignmentDto> {
    const response = await http.post<PositionAssignmentDto>(
      `/settings/positions/${positionId}/assignments`, payload
    )
    return response.data
  },
  async removeAssignment(assignmentId: number): Promise<void> {
    await http.delete<void>(`/settings/positions/assignments/${assignmentId}`)
  },
  async autoIdentities(): Promise<AutoIdentityDto[]> {
    const response = await http.get<AutoIdentityDto[]>('/settings/positions/auto-identities')
    return normalizeListResponse<AutoIdentityDto>(response.data)
  },
  async headTeacherClasses(): Promise<HeadTeacherClassDto[]> {
    const response = await http.get<HeadTeacherClassDto[]>('/settings/positions/head-teachers')
    return normalizeListResponse<HeadTeacherClassDto>(response.data)
  },
  async assignHeadTeacher(classId: number, staffId: number): Promise<HeadTeacherClassDto> {
    const response = await http.put<HeadTeacherClassDto>(
      `/settings/positions/head-teachers/${classId}`, { staffId }
    )
    return response.data
  },
  async clearHeadTeacher(classId: number): Promise<void> {
    await http.delete<void>(`/settings/positions/head-teachers/${classId}`)
  }
}
